import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";

import AdminStats from "./AdminStats";
import AdminInfo from "./AdminInfo";
import AdminManagement from "./AdminManagement";
import AuthStatus from "./AuthStatus";
import RoleManagement from "./RoleManagement";

const Dashboard = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Admin" parent="Admin" title="Admin" />
      <Container fluid={true}>
        <Row className="widget-grid">
          <AuthStatus />
          <AdminInfo />
          <RoleManagement />
          <AdminStats />
          <AdminManagement />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Dashboard;
